import _ from "lodash";
import React, { Component } from "react";

import "./styles.scss";

class Accordion extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="py-3">
        <h2 className="mb-0">
          <button
            aria-controls={this.props.ariaControls}
            aria-expanded="false"
            className="AccordionBtn fs-14 text-left collapsed"
            data-target={this.props.dataTarget}
            data-toggle="collapse"
            type="button"
          >
            {this.props.text}
          </button>
        </h2>

        <div
          aria-labelledby={this.props.ariaLabelledby}
          className="collapse"
          data-parent="#AptiAccordion"
          id={this.props.contentId}
        >
          <div className="px-3 mt-4">
            {this.props.info &&
              this.props.info.map((items) => {
                if (items.hasOwnProperty("type") && items["type"] === "img" && items["value"]) {
                  if (!_.get(items, "value[0]") && !_.get(items, "value[1]")) {
                    return <></>;
                  }

                  return (
                    <div className="mt-4" data-private="true" key={items.property}>
                      <p className="mb-2 fs-14 tw:font-bold">{items.property}</p>
                      {items["value"].map((item, index) => {
                        return (
                          <img
                            alt=""
                            className="PatientProfile__insurance-image-preview cursor"
                            key={item + `${index}`}
                            onClick={
                              items.hasOwnProperty("onclick") ? () => items["onclick"](item) : null
                            }
                            src={item}
                          />
                        );
                      })}
                    </div>
                  );
                } else {
                  return (
                    <div className="mt-4" key={items.property}>
                      <p className="mb-2 fs-14 tw:font-bold">{items.property}</p>
                      <p className="mb-0 fs-14">{items.value}</p>
                    </div>
                  );
                }
              })}
          </div>
        </div>
      </div>
    );
  }
}

export default Accordion;
